import { useState, useCallback } from "react";

/**
 * Estado y helpers para el Snackbar genérico del módulo Administration.
 *
 * Devuelve:
 *  - snack: { open, message, severity }
 *  - showSnack(message, severity = "success")
 *  - closeSnack()
 *
 * El componente que lo usa debe renderizar un MUI <Snackbar> con
 * snack.open / snack.message / snack.severity y conectar onClose a closeSnack.
 */
const useSnack = () => {
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const showSnack = useCallback((message, severity = "success") => {
    setSnack({ open: true, message, severity });
  }, []);

  const closeSnack = useCallback(() => {
    setSnack((s) => ({ ...s, open: false }));
  }, []);

  return { snack, showSnack, closeSnack };
};

export default useSnack;
